
<template>
  <page-list
    :list="list"
    :columns="columns"
    :show-tag-columns="false" />
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'DownloadHistoryList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        // id: this.id,
        resource: 'downloadrecords',
      }),
    }
  },
  created () {
    this.list.fetchData()
  },
}
</script>
